var rtlStyles = {"rtl":"frz7f","ltr":"AnCKd"};

export { rtlStyles as r };
//# sourceMappingURL=rtl.rtlignore-04b2d7e3.js.map
